module.exports = __webpack_public_path__ + "assets/blog-bg-0.5x.88ddaf05.webp";